import React, { useEffect } from 'react';
import NavBar from '../../components/NavBar/NavBar';
function Profile_Details() {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div>
            <NavBar />
            <section className="content home">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>View User Details
                                <small className="text-muted"></small>
                            </h2>
                        </div>
                    </div>
                </div>

                <div className="row clearfix d-flex justify-content-center" >
                    <div className="col-lg-9 col-md-12">

                        <div className="card member-card" >
                            <div className="header l-slategray">
                                <h4 className="m-t-10">Name</h4>
                            </div>
                            <div className="member-img">
                                <img src={window.location.origin + "/images/user_profile.jpg"} className="rounded-circle" alt={"img"} style={{ "width": "200", "height": "200" }} />
                            </div>
                            <div className="body">
                                <div className="col-12">
                                    <h5>Message</h5>
                                    <p className="text-muted">Message</p>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-3">
                                        <h5>UserName</h5>
                                        <small>UserName</small>
                                    </div>
                                    <div className="col-3">
                                        <h5>Gender</h5>
                                        <small>Male</small>
                                    </div>
                                    <div className="col-3">
                                        <h5>Age</h5>
                                        <small>18</small>
                                    </div>
                                    <div className="col-3">
                                        <h5>Country</h5>
                                        <small>India</small>
                                    </div>
                                </div>
                                <br /><br /><br />
                                <div className="row">
                                    <div className="col-3">
                                        <h5>Date Of Birth</h5>
                                        <small>2023/08/20</small>
                                    </div>
                                    <div className="col-3">
                                        <h5>Weight</h5>
                                        <small>cdscs</small>
                                    </div>
                                    <div className="col-3">
                                        <h5>Height</h5>
                                        <small>c scs</small>
                                    </div>
                                    <div className="col-3">
                                        <h5>Status</h5>
                                        <small>{"InActive" == 'inactive' ? "🔴 InActive" : "🟢 Active"}</small>
                                    </div>
                                </div>
                                <br /><br /><br />
                                <div className="row">
                                    <div className="col-3">
                                        <h5>Wellness Goals</h5>
                                        <small>cdcdsx</small>
                                    </div>
                                    <div className="col-3">
                                        <h5>Interest</h5>
                                        <small>dxcdscs</small>
                                    </div>

                                </div>
                                {/* {img == '' ? "" : <><br/><br/><hr/><br/><h5 className='col-2'>User Images</h5><br/></> }
                    <div className="row">
                      {img == '' ? "" : img.map((el,i) => <div className='col-3' key={i}><img className="rounded" alt="user-image" style={{width: 250, height: 300}} src={el.image}/></div> )}
                    </div>

                    {highlight == '' ? "" : <><br/><br/><hr/><br/><h5 className='col-2'>User Highlight's</h5><br/> </>}
                      <div className='row'>
                      {highlight == '' ? "" : highlight.map((el,i) => <div className='col-3' key={i}><img className="rounded" alt="highlight-image" style={{width: 250, height: 300}} src={el.image}/><br/><small>Type : {el.type}</small><br/><small>Name : {el.name}</small></div> )}
                      </div> */}
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </div>
    );
}

export default Profile_Details;